const socialMediaLinks = {
  facebook: 'https://www.facebook.com/prvikorak.info',
  tiktok: 'https://www.tiktok.com/@mamazapet',
  instagram: 'https://www.instagram.com/mamazapet/?hl=en',
};

export default socialMediaLinks;
